import track from 'react-tracking';
import CopyTruncator from '@/components/CopyTruncator';
import DeprecatedKeyMetric from '@/components/DeprecatedKeyMetric';
import { Row } from '@simplywallst/ui-core';
import { LeaderBiography, KeyMetricWrapper, NoCEO, Capper } from './styled';
import { ViewMode } from '@/pages/CompanyReport/enum';
import If from '@/components/If';

export interface LeaderProps {
  hasCEO: boolean;
  leaderAge: number;
  companyName: string;
  leaderCompensation: string;
  leaderTenure: string;
  leaderYearBorn: number;
  leaderLastName: string;
  leaderBiography: string;
  leaderSalutation: string;
  viewMode: ViewMode;
}

const Leader = ({
  hasCEO,
  viewMode,
  leaderAge = 0,
  companyName = '',
  leaderCompensation = '',
  leaderTenure = '',
  leaderYearBorn = 0,
  leaderLastName = '',
  leaderBiography = '',
  leaderSalutation = '',
}: LeaderProps) => {
  const hasLeaderAge = typeof leaderAge === 'number' && leaderAge > 0;
  const hasLeaderTenure =
    typeof leaderTenure !== 'undefined' && leaderTenure !== '0';
  return hasCEO ? (
    <>
      <div>
        <p data-cy-id="ceo-name-age">
          <strong>
            <span itemProp="givenName">{`${leaderSalutation} `}</span>
            <span itemProp="familyName">{`${leaderLastName} `}</span>
            <If match={hasLeaderAge}>
              <span itemProp="age">{`(${leaderAge} yo)`}</span>
            </If>
          </strong>
        </p>
        <meta itemProp="birthDate" content={`${leaderYearBorn}`} />
      </div>
      <Row>
        <If match={hasLeaderTenure}>
          <KeyMetricWrapper col={12} colSm={4}>
            <DeprecatedKeyMetric
              title="Tenure"
              size="large"
              metric={<Capper>{leaderTenure}</Capper>}
            />
          </KeyMetricWrapper>
        </If>
        <If match={leaderCompensation !== ''}>
          <KeyMetricWrapper col={12} colSm={4}>
            <DeprecatedKeyMetric
              title="Compensation"
              size="large"
              metric={leaderCompensation}
            />
          </KeyMetricWrapper>
        </If>
      </Row>
      {leaderBiography && (
        <LeaderBiography>
          <CopyTruncator
            content={leaderBiography}
            defaultToOpen={viewMode === ViewMode.Print}
          />
        </LeaderBiography>
      )}
    </>
  ) : (
    <NoCEO>{`${companyName} has no CEO, or we have no data on them.`}</NoCEO>
  );
};

export default track({
  type: 'track',
  subject: 'ceo_bio',
})(Leader) as typeof Leader;
